import { createIcon } from '@consta/icons/Icon'
import type { FC, SVGProps } from 'react'

const IconCartographyM: FC<SVGProps<SVGSVGElement>> = props => (
  <svg viewBox="0 0 13 13" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M 7.5612 0 L 11.8071 2.1938 L 13.065 7.6098 L 10.8686 11.4534 L 5.4827 13.0692 L 1.2576 10.8679 L 0 5.2367 L 2.542 1.2967 L 7.5612 0 Z M 1.3493 4.9899 L 3.8454 3.5636 L 7.9721 2.5319 H 10.283 L 7.4415 1.0638 L 3.1704 2.1671 L 1.3493 4.9899 Z M 11.0913 3.5319 H 8.0952 L 4.2218 4.5002 L 1.2406 6.2038 L 2.0169 9.6798 L 4.8454 8.0636 L 8.9721 7.0319 H 11.9042 L 11.0913 3.5319 Z M 5.5845 11.9946 L 2.6538 10.4677 L 5.2218 9.0002 L 9.0952 8.0319 H 11.672 L 10.1986 10.6104 L 5.5845 11.9946 Z"
    />
  </svg>
)

export const IconCartography = createIcon({
  name: 'IconCartography',
  l: IconCartographyM,
  m: IconCartographyM,
  s: IconCartographyM,
  xs: IconCartographyM,
})
